import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["list", "itemTemplate"]
  static values = { url: String }

  add(event) {
    event.preventDefault()
    const name = window.prompt("New frequency name:")
    if (!name || !name.trim()) return

    fetch(this.urlValue, {
      method: "POST",
      headers: { "Content-Type": "application/json", "X-CSRF-Token": this.#csrfToken() },
      body: JSON.stringify({ team_playbook_frequency: { name: name.trim() } }),
    })
      .then((r) => r.ok ? r.json() : r.json().then((d) => { alert(d.errors?.join(", ") || "Failed"); throw new Error() }))
      .then((data) => {
        this.#appendItem(data)
        this.#broadcast()
      })
      .catch(() => {})
  }

  rename(event) {
    event.preventDefault()
    event.stopPropagation()
    const { frequencyId, frequencyName } = event.currentTarget.dataset
    const newName = window.prompt("Rename frequency:", frequencyName)
    if (!newName || !newName.trim() || newName.trim() === frequencyName) return

    fetch(`${this.urlValue}/${frequencyId}`, {
      method: "PATCH",
      headers: { "Content-Type": "application/json", "X-CSRF-Token": this.#csrfToken() },
      body: JSON.stringify({ team_playbook_frequency: { name: newName.trim() } }),
    })
      .then((r) => r.ok ? r.json() : r.json().then((d) => { alert(d.errors?.join(", ") || "Failed"); throw new Error() }))
      .then((data) => {
        const li = this.listTarget.querySelector(`[data-frequency-id="${data.id}"]`)
        if (li) {
          const badge = li.querySelector("[data-frequency-badge]")
          if (badge) badge.textContent = data.name
          li.querySelectorAll("[data-frequency-name]").forEach((el) => el.dataset.frequencyName = data.name)
        }
        this.#broadcast()
      })
      .catch(() => {})
  }

  remove(event) {
    event.preventDefault()
    event.stopPropagation()
    const { frequencyId, frequencyName } = event.currentTarget.dataset
    const input = window.prompt(`Delete "${frequencyName}"? This will clear it from all rows.\n\nType CONFIRM to proceed:`)
    if (input !== "CONFIRM") return

    fetch(`${this.urlValue}/${frequencyId}`, {
      method: "DELETE",
      headers: { "X-CSRF-Token": this.#csrfToken() },
    })
      .then((r) => {
        if (!r.ok) throw new Error()
        const li = this.listTarget.querySelector(`[data-frequency-id="${frequencyId}"]`)
        li?.remove()
        this.#broadcast()
      })
      .catch(() => alert("Failed to delete frequency"))
  }

  #appendItem(data) {
    const clone = this.itemTemplateTarget.content.cloneNode(true)
    clone.querySelectorAll("[data-frequency-id]").forEach((el) => el.dataset.frequencyId = data.id)
    clone.querySelectorAll("[data-frequency-name]").forEach((el) => el.dataset.frequencyName = data.name)
    const badge = clone.querySelector("[data-frequency-badge]")
    if (badge) badge.textContent = data.name
    this.listTarget.appendChild(clone)
  }

  #broadcast() {
    document.dispatchEvent(new CustomEvent("team-playbook:frequencies-changed"))
  }

  #csrfToken() {
    return document.querySelector('meta[name="csrf-token"]')?.content || ""
  }
}
